import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";

import type { DocumentTemplateResource } from "@exonn/js-sdk";
import type { Module } from "src/system/module.types.ts";

export const module: Module<DocumentTemplateResource> = {
  id: ResourceEnum.DocumentTemplate,
  bigIcon: <span className={"icon-20-dok_templ"} />,
  smallIcon: <span className={"icon-15-dok_templ"} />,
  name: (t: TFunction) => t("moduleName.document-template"),
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
};
